import React from "react"
import EventSection2 from "../theme/components/event2";
import {applyLang} from "../../../i18n";
import {fetchEvents} from "../../../services/EventService";


export default class PreviewEvents extends React.Component{

  state = { events: [], eventGroupes: [], loading: true }

  componentDidMount() {
    const org = this.props.context?.org
    if (org) fetchEvents(org.id, {virtualId: org.virtualId || null}).then(d => this.setState({ events: d.events, eventGroupes: d.eventGroupes, loading: false }))
    else this.setState({ loading: false })
  }

  isFloat(n){
    return Number(n) === n && n % 1 !== 0;
  }

  getEvents()
  {
    // Événements issus de /v1/events (fetch client), plus de org.events.
    const events = this.state.events

    if(!Array.isArray(events)){
      return []
    }

    var date=new Date()
    date.setHours(0,0,0)


    return events.filter((i)=>new Date(i.dateFin)>=date).sort((a,b)=>{
      if(a.dateEvent==b.dateEvent){
        return 0
      }
      return a.dateEvent>b.dateEvent?1:-1
    }).slice(0,2).map(i=>applyLang(i,this.props.context.lang))

  }


  render()
  {
    const context=this.props.context
    const {org}=context

    if(!org){
      return null
    }

    var events=this.getEvents()


    if(events.length==0){
      return null
    }

    return (
        <EventSection2 context={context} events={events} EventClass={'wpo-event-area-2'}/>
    )

  }
}
